module.exports = __webpack_public_path__ + "img/client.00cc6fe8.png";